import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import Button from 'antd/lib/button';
import Icon from 'antd/lib/icon';
import Select from 'antd/lib/select';
import Table from 'antd/lib/table';
import { ResponsiveTable, OpenFileLink } from '../../../../common/components/data-display';
import { accountDocumentTypesT } from '../../../../common/enums';

const Column = Table.Column;
const Option = Select.Option;

const DocumentsList = ({ documents, onAccountDocumentRemove, onFileTypeChange, t, token, showCreatedAt }) =>
  documents.length > 0 ? (
    <section className="documents-wrapper">
      <ResponsiveTable dataSource={documents}>
        <Column
          dataIndex="file"
          key="fileSelect"
          title={t('Typ zmluvy')}
          render={(file, doc) => (
            <Select onChange={onFileTypeChange(file.id)} value={doc.type}>
              {Object.entries(accountDocumentTypesT).map(([key, value]) => (
                <Option key={file.id + key} value={key}>
                  {value}
                </Option>
              ))}
            </Select>
          )}
        />
        <Column title={t('Názov')} dataIndex="file" key="name" render={file => file.name} />
        <Column
          dataIndex="file"
          key="download"
          title=""
          render={file => (
            <OpenFileLink href={`${file.link}?token=${token}`}>
              {t('Otvoriť dokument')}
            </OpenFileLink>
          )}
        />
        <Column
          dataIndex="file"
          key="actions"
          title={t('Akcie')}
          render={file => (
            <Button size="small" icon="delete" onClick={onAccountDocumentRemove(file.id)} />
          )}
        />
         {showCreatedAt && (
          <Column
            title={t('Dátum nahrania')}
            dataIndex="file"
            key="updatedAt"
            render={file => {
              return new Date(file.updatedAt).toLocaleString()
            }}
          />
        )}
      </ResponsiveTable>
    </section>
  ) : (
    <p>
      <Icon type="info-circle-o" /> {t('Neexistujú žiadne zmluvy.')}
    </p>
  );

DocumentsList.propTypes = {
  documents: PropTypes.array.isRequired,
  t: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

export default translate()(DocumentsList);



// WEBPACK FOOTER //
// ./src/features/account-management/components/documents/DocumentsList.js